module.exports = __webpack_public_path__ + "static/media/pm_hc_result_interpretation_2.5c8f1ae1.png";